module.exports = __webpack_public_path__ + "img/em11.7c315904.jpg";